module.exports = __webpack_public_path__ + "img/sport-6-@1x.3ea88997.png";